import React from 'react';
import {useAppSelector} from '../../utils/customHooks';

const SnackBar = () => {
    const {appMessage, errorMessage} = useAppSelector(state => state.app)
    const bgStyle = appMessage ? 'bg-neutral-200 text-gray-500' : 'bg-red-600 text-gray-200'
    const isDisplay = (appMessage || errorMessage) ? 'display-block' : 'hidden'
    return (
        <div className={`${isDisplay} ${bgStyle} fixed bottom-4 left-4 max-w-[320px] z-50 rounded-lg drop-shadow-md`}>
            <p className={'m-3'}>{appMessage || errorMessage}</p>
        </div>
    );
};

export default SnackBar;